// test1247
(1247 && 0);
